/* eslint-disable */
import { create } from '../utils/sigpipe'

// import { GoogleCharts } from 'google-charts'

export default {
  name: 'graph',

  componentDidMount() {
    this.type = this.props.type

    this.pipe = create()
    this.el.setAttribute('data-pipe-id', this.pipe.id)
    this.pipe.on(({ action }) => {
      switch (action) {
        case 'draw':
          //GoogleCharts.load(this.drawChart)
          this.drawChart()
          this.pipe.destroy()
          break
      }
    })

    // GoogleCharts.load(drawGeoChart, {
    //   'packages': ['geochart'],
    //   'mapsApiKey': 'AIzaSyA7DE6KbMgcLZwmfYWUL7Z_gr5RVoycLD8'
    // })
  },

  drawChart() {
    let dataTable = 'DataTable'
    /* switch (this.type) {
      case 'PieChart':
        dataTable = 'arrayToDataTable'
        break
    }*/
    let data = new google.visualization[dataTable]()
    // data.addColumn('string', this.props.dataLabel)
    // data.addColumn('number', this.props.dataUnit)
    for (let i = 0; i < this.props.dataCols.length; i++) {
      const col = this.props.dataCols[i]
      data.addColumn(col[0], col[1])
    }

    data.addRows(this.props.dataGraph)

    /*
    for (var key in this.props.datarow) {
      data.addRow([key, this.props.datarow[key]])
    }*/
    // console.log('type', this.type)

    let options = this.props.options || {}

    //let graph = new GoogleCharts.api.visualization.PieChart(this.el)
    // let graph = new GoogleCharts.api.visualization[this.type](this.el)
    let graph = new google.visualization[this.type](this.el)

    graph.draw(data, options)

    if (this.type === 'Table' && this.props.highlitedCol) {
      Array.prototype.forEach.call(
        this.el.querySelectorAll('table tr'),
        row => {
          Array.prototype.forEach.call(
            this.props.highlitedCol,
            selectedColIndex => {
              let cols = row.querySelector('td')
                ? row.querySelectorAll('td')
                : row.querySelectorAll('th')

              // cols[selectedColIndex].classList.add('is-highlitedCol')
              // refact for IE 11
              cols[selectedColIndex].className += ' is-highlitedCol'
            }
          )
        }
      )
      /*for (let row of this.el.querySelectorAll('table tr')) {
        for (let selectedColIndex of this.props.highlitedCol) {
          let cols = row.querySelector('td')
            ? row.querySelectorAll('td')
            : row.querySelectorAll('th')
          cols[selectedColIndex].classList.add('is-highlitedCol')
        }
      }*/
    }
  },

  executeFunctionByName(functionName, context, args) {
    var args = Array.prototype.slice.call(arguments, 2)
    var namespaces = functionName.split('.')
    var func = namespaces.pop()
    for (var i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]]
    }
    return context[func].apply(context, args)
    // return context[func](args);
  },
}
